import React, { useState, useEffect, createContext } from "react";
import { AnimatePresence } from "framer-motion";
import { Analytics } from "@vercel/analytics/react";
import Preloader from "../src/components/Pre";
import { SpeedInsights } from "@vercel/speed-insights/react";
import VisitNotifier from "./components/VisitNotifier";
import ChatBot from "./components/AIChatbot/ChatBot";
import Dashboard from "./components/Dashboard/Dashboard";
import SkillVisualization from "./components/SkillVisualization/SkillVisualization";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Experience from "./components/Experience/Experience";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import Certification from "./components/Certficiation/Certification";
import Contact from "./components/Contact/Contact";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Create future flags object to suppress React Router v7 warnings
const ROUTER_FUTURE_CONFIG = {
  v7_startTransition: true,
  v7_relativeSplatPath: true
};

export const LoadingContext = createContext();

function App() {
  const [load, updateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router future={ROUTER_FUTURE_CONFIG}>
      <LoadingContext.Provider value={{ load, updateLoad }}>
        <Preloader load={load} />
        <div className="App" id={load ? "no-scroll" : "scroll"}>
          <Navbar />
          <ScrollToTop />
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/project" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/resume" element={<Resume />} />
              <Route path="/certification" element={<Certification />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/dash" element={<Dashboard />} />
              <Route path="/skills-ai" element={<SkillVisualization />} />
              <Route path="*" element={<Navigate to="/"/>} />
            </Routes>
          </AnimatePresence>
          <Footer />
        </div>
        <Analytics />
        <VisitNotifier />
        <ChatBot />
        <SpeedInsights />
      </LoadingContext.Provider>
    </Router>
  );
}

export default App;
